<template>
  <PageManager
    :iframe-target="`${link}/${pageUrl}`"
    :page="page"
    :overrides="pages"
  >

    <template #before-sidebar>
      <NavigationSidebar
        :pages="pages"
        v-model="page"
      >
        <template v-slot="{ id }">
          <svg v-if="id === LOGIN" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M3 3a1 1 0 011 1v12a1 1 0 11-2 0V4a1 1 0 011-1zm7.707 3.293a1 1 0 010 1.414L9.414 9H17a1 1 0 110 2H9.414l1.293 1.293a1 1 0 01-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0z" clip-rule="evenodd" />
          </svg>
          <svg v-else-if="id === REGISTER" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path d="M8 9a3 3 0 100-6 3 3 0 000 6zM8 11a6 6 0 016 6H2a6 6 0 016-6zM16 7a1 1 0 10-2 0v1h-1a1 1 0 100 2h1v1a1 1 0 102 0v-1h1a1 1 0 100-2h-1V7z" />
          </svg>
          <svg v-else-if="id === FORGOT" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5">
            <path d="M3.478 2.405a.75.75 0 00-.926.94l2.432 7.905H13.5a.75.75 0 010 1.5H4.984l-2.432 7.905a.75.75 0 00.926.94 60.519 60.519 0 0018.445-8.986.75.75 0 000-1.218A60.517 60.517 0 003.478 2.405z" />
          </svg>
          <svg v-else-if="id === RESET" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5">
            <path fill-rule="evenodd" d="M15.75 1.5a6.75 6.75 0 00-6.651 7.906c.067.39-.032.717-.221.906l-6.5 6.499a3 3 0 00-.878 2.121v2.818c0 .414.336.75.75.75H6a.75.75 0 00.75-.75v-1.5h1.5A.75.75 0 009 19.5V18h1.5a.75.75 0 00.53-.22l2.658-2.658c.19-.189.517-.288.906-.22A6.75 6.75 0 1015.75 1.5zm0 3a.75.75 0 000 1.5A2.25 2.25 0 0118 8.25a.75.75 0 001.5 0 3.75 3.75 0 00-3.75-3.75z" clip-rule="evenodd" />
          </svg>
        </template>
      </NavigationSidebar>
    </template>

  </PageManager>
</template>

<script>

import NavigationSidebar from "@/components/SideEditor/NavigationSidebar"
import PageManager from "@/components/SideEditor/PageManager.vue"

import { mapGetters } from "vuex"

const LOGIN = 'authentication-login'
const REGISTER = 'authentication-register'
const FORGOT = 'authentication-forgotpassword'
const RESET = 'authentication-createpassword'

export default {
  components: {
    PageManager,
    NavigationSidebar,
  },
  data() {
    return {
      LOGIN, REGISTER, FORGOT, RESET,

      page: null,
      pages: [
        {
          name: "Login",
          id: LOGIN,
        },
        {
          name: "Register",
          id: REGISTER,
        },
        {
          name: "Forgot password",
          id: FORGOT,
        },
        {
          name: "Create password",
          id: RESET,
        },
      ],
    }
  },
  beforeDestroy() {
    // this.$store.dispatch("editor/context", null)
  },
  computed: {
    ...mapGetters({
      link: 'editor/fullDomainLink',
    }),

    pageUrl() {
      switch (this.page) {
        case LOGIN: return "customer/account/login"
        case REGISTER: return "customer/account/create"
        case FORGOT: return "customer/account/forgotpassword"
        case RESET: return "backoffice-createpassword-page-configuration"
      }
    },
  },
}

</script>
